import * as s from '~js/utils/selectors';
import * as a from '~js/utils/attributes';
import * as c from '~js/utils/classes';
import { Ticker } from '~js/components/ticker';

const Flickity = themeVendor.Flickity

const tags = {
  clipPath: 'clipPath',
};

export class AnnouncementBar {
  constructor(container) {
    this.barHolder = container;
    this.locationPath = location.href;
    this.slides = this.barHolder.querySelectorAll(s.selectors$D.slide);
    this.slider = this.barHolder.querySelector(s.selectors$D.slider);
    this.tickers = [];
    this.flkty = null;

    this.init();
  }

  init() {
    this.removeAnnouncement();

    if (this.slider) {
      this.initSlider();
      document.addEventListener('theme:resize:width', this.initSlider.bind(this));
    }

    if (!this.slider) {
      this.initTickers(true);
      this.tickerAnimationPause();
    }

    this.updateSVGClipPathIDs();
  }

  /**
   * Delete announcement which has a target referrer attribute and it is not contained in page URL
   */
  removeAnnouncement() {
    for (let i = 0; i < this.slides.length; i++) {
      const element = this.slides[i];

      if (!element.hasAttribute(a.attributes$o.targetReferrer)) {
        continue;
      }

      if (
        this.locationPath.indexOf(element.getAttribute(a.attributes$o.targetReferrer)) === -1 &&
        !window.Shopify.designMode
      ) {
        element.parentNode.removeChild(element);
      }
    }
  }

  /**
   * Init slider
   */
  initSlider() {
    const slides = this.slider.querySelectorAll(s.selectors$D.slide);
    const sliderArrows = this.slider.hasAttribute(a.attributes$o.arrows);

    if (slides) {
      let slideSelector = `${s.selectors$D.slide}`;

      if (window.innerWidth < theme.sizes.small) {
        slideSelector = `${s.selectors$D.slide}:not(.${c.classes$t.desktop})`;
      } else {
        slideSelector = `${s.selectors$D.slide}:not(.${c.classes$t.mobile})`;
      }

      if (this.flkty != null) {
        this.flkty.destroy();
      }

      this.flkty = new Flickity(this.slider, {
        cellSelector: slideSelector,
        pageDots: false,
        prevNextButtons: sliderArrows,
        wrapAround: true,
        autoPlay: parseInt(this.slider.getAttribute(a.attributes$o.speed), 10),
        on: {
          ready: () => {
            setTimeout(() => {
              this.slider.dispatchEvent(
                new CustomEvent('slider-is-loaded', {
                  bubbles: true,
                  detail: {
                    slider: this,
                  },
                })
              );
            }, 10);
          },
        },
      });
      this.flkty.reposition();
    }

    this.slider.addEventListener('slider-is-loaded', () => {
      this.initTickers();
      this.updateSVGClipPathIDs();
    });
  }

  /**
   * Init tickers in sliders
   */
  initTickers(stopClone = false) {
    const frames = this.barHolder.querySelectorAll(s.selectors$D.frame);

    frames.forEach((element) => {
      const ticker = new Ticker(element, stopClone);
      this.tickers.push(ticker);

      const slides = element.querySelectorAll(s.selectors$D.slide);
      if (slides.length !== 0) {
        const slidesMobile = element.querySelectorAll(`${s.selectors$D.slide}.${c.classes$t.mobile}`);
        const slidesDesktop = element.querySelectorAll(`${s.selectors$D.slide}.${c.classes$t.desktop}`);

        if (slides.length === slidesMobile.length) {
          element.parentNode.classList.add(c.classes$t.mobile);
        } else if (slides.length === slidesDesktop.length) {
          element.parentNode.classList.add(c.classes$t.desktop);
        }
      }
    });
  }

  toggleTicker(e, isStopped) {
    const tickerScale = e.target.closest(s.selectors$D.tickerScale);
    const element = document.querySelector(`[${a.attributes$o.slide}="${e.detail.blockId}"]`);

    if (isStopped && element) {
      tickerScale.setAttribute(a.attributes$o.stop, '');
      tickerScale.querySelectorAll(s.selectors$D.tickerText).forEach((textHolder) => {
        textHolder.classList.remove(c.classes$t.tickerAnimated);
        textHolder.style.transform = `translate3d(${-(
          element.offsetLeft - parseInt(getComputedStyle(element).marginLeft, 10)
        )}px, 0, 0)`;
      });
    }

    if (!isStopped && element) {
      tickerScale.querySelectorAll(s.selectors$D.tickerText).forEach((textHolder) => {
        textHolder.classList.add(c.classes$t.tickerAnimated);
        textHolder.removeAttribute(a.attributes$o.style);
      });
      tickerScale.removeAttribute(a.attributes$o.stop);
    }
  }

  tickerAnimationPause() {
    let hoverTimer = 0;
    let isHovered = false;
    const tickerContainer = this.barHolder.querySelector(s.selectors$D.announcementSlide);

    tickerContainer.addEventListener('mouseenter', () => {
      isHovered = true;

      hoverTimer = setTimeout(() => {
        if (isHovered) {
          tickerContainer.querySelectorAll(s.selectors$D.tickerText).forEach((element) => {
            element.style.animationPlayState = 'paused';
          });
        }

        clearTimeout(hoverTimer);
      }, 500);
    });

    tickerContainer.addEventListener('mouseleave', () => {
      isHovered = false;

      tickerContainer.querySelectorAll(s.selectors$D.tickerText).forEach((element) => {
        element.style.animationPlayState = 'running';
      });
    });
  }

  updateSVGClipPathIDs() {
    this.barHolder.querySelectorAll(s.selectors$D.slide).forEach((svg, index) => {
      const clipPath = svg.querySelector(tags.clipPath);

      if (clipPath) {
        const newclipPathId = `${clipPath.id}_${index}`;

        // Update the clipPath ID
        clipPath.id = newclipPathId;

        // Update the 'clip-path' URL reference in the <g> tag
        const gTag = svg.querySelector(`g[${a.attributes$o.clipPath}]`);
        if (gTag) {
          gTag.setAttribute(a.attributes$o.clipPath, `url(#${newclipPathId})`);
        }
      }
    });
  }

  onBlockSelect(evt) {
    const index = parseInt([...evt.target.parentNode.children].indexOf(evt.target));

    if (this.slider && this.flkty !== null) {
      this.flkty.select(index);
      this.flkty.pausePlayer();
    }
    if (!this.slider) {
      this.toggleTicker(evt, true);
    }
  }

  onBlockDeselect(evt) {
    if (this.slider && this.flkty !== null) {
      this.flkty.unpausePlayer();
    }
    if (!this.slider) {
      this.toggleTicker(evt, false);
    }
  }

  onUnload() {
    document.removeEventListener('theme:resize:width', this.initSlider.bind(this));

    if (this.tickers.length > 0) {
      this.tickers.forEach((ticker) => {
        ticker.unload();
      });
    }
  }
}